/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-01-07 10:14:50
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-17 11:47:55
 */
import request from '../../utils/request'
import server from './config'
export default {
    /**
     * 获取协议详情
     */
    getDetail:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/agreement/1/getDetailByTypeCode`,
            method: 'post',
            data,
        })
    },
    /**
     * 获取用户未签署协议列表
     */
    getNotSignAgreement:(data,noToast = false)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/agreement/1/getAgreementUpdateList`,
            method: 'post',
            data,
            noToast
        })
    },
    /**
     * 签署协议
     */
    signAgreement:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/agreement/1/signAgreement`,
            method: 'post',
            data,
        })
    },

    /**
     * 获取协议历史版本
     */
    getVersion: (data) => {
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/agreement/1/getAgreementLogList`,
            method: 'post',
            data,
        })
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/agreement.js